import React from "react";
import { Box } from "@mui/material";
import DetailePageStyles from "../../../../utilities/DetailePageStayles";

type TableComponentProps = {
    fields: any;
    data: any;
    getMappedValue: <T extends { name: string; value: any }, U>(field: T, data: U, mappers: Record<string, (value: any) => any>) => any
    monitoringValueMappers?: any;
    headers: string[];
};

const TableComponent: React.FC<TableComponentProps> = ({ fields, data, getMappedValue, monitoringValueMappers, headers }) => {
    const classes = DetailePageStyles();
    const rows = [];
    for (let i = 0; i < fields.length; i += 3) {
        rows.push(fields.slice(i, i + 3));
    }

    return (
        <table className={classes.table}>
            <thead>
                <tr>
                    <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>პროექტის ფარგლებში განხორციელებული ხარჯვა;</th>
                    <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>მიზნობრივი ხარჯვა;</th>
                    <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>არამიზნობრივი ხარჯვა;<i style={{
                        fontSize: "10px",
                        fontWeight: 100,
                        color: "rgb(0, 0, 0, 0.8)",
                    }}>(მოიცავს შემდეგს: არ არის შეძენილი გუდვილი; არ არის შეძენილი სატრანსპორტო საშუალებები და არ განხორციელებულა მათი რემონტი, გარდა სპეციალური საშუალებებისა, რომლებიც უშუალოდ გამოიყენება საწარმოს ტერიტორიაზე პროდუქციის/მომსახურების წარმოების პროცესში; სახელმწიფო ან/და კერძო საკუთრებაში არსებული უძრავი ქონების შეძენა ან/და საქართველოს სამოქალაქო კოდექსით გათვალისწინებული ფორმებით დროებით სარგებლობაში აღება; კერძო სამართლის იურიდიული პირის აქციების ან წილების შეძენა ან მართვაში აღება; საქართველოს კანონმდებლობის შესაბამისად გათვალისწინებული სახდელების (ჯარიმა, საურავი, პირგასამტეხლო და სხვა) გადახდა/დაფარვა)</i> </th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row, index) => (
                    <tr key={`${index}`}
                        style={{
                            borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
                            borderTop: "1px solid rgb(0, 0, 0, 0.23)",
                        }}
                    >
                        {row.map((field: any, i: number) => (
                            <td
                                key={`${index}-${i}`}
                                style={{
                                    padding: "8px",
                                    fontSize: "12px",
                                }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        minHeight: "50px", // Ensures enough height
                                    }}
                                >
                                    <label style={{
                                        fontSize: "11px",
                                        color: "rgb(0, 0, 0, 0.8)",
                                    }}>{field.label}</label>
                                    {getMappedValue(field, data, monitoringValueMappers)}

                                </Box>
                            </td>

                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableComponent;
